export function logClient(level, message, context = {}) {
  try {
    // ensure logging request does not trigger global error redirects
    // Ensure context is an object
    context = context || {};
    // Default fields for client logs
    if (!context.service) context.service = "frontend";
    // Avoid importing the shared api helper here (prevents chunk-splitting and circular deps).
    // Use a minimal fetch so logging stays fire-and-forget and keeps logger decoupled.
    try {
      fetch("/log/client", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Skip-Error-Redirect": "1",
        },
        body: JSON.stringify({ level, message, context }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) {}
    // Note: if authentication headers or a different base URL are required, we can add them here or
    // implement a tiny dedicated logging endpoint wrapper that does not pull in the full `api` module.
  } catch (e) {
    // ignore
  }
  const fn = console[level] || console.log;
  fn(`[${level}] ${message}`, context);
}

export function installGlobalErrorHandlers() {
  if (window.__FE_LOG_INSTALLED__) return;
  window.__FE_LOG_INSTALLED__ = true;
  window.addEventListener("error", (e) => {
    logClient("error", e.message || "script error", {
      source: e.filename,
      line: e.lineno,
      col: e.colno,
      stack: e.error && e.error.stack ? e.error.stack : undefined,
      event_type: "global.error",
    });
  });
  window.addEventListener("unhandledrejection", (e) => {
    logClient("error", "unhandled rejection", {
      reason: String(e.reason),
      stack: e.reason && e.reason.stack ? e.reason.stack : undefined,
      event_type: "global.unhandledrejection",
    });
  });
}
